require('./kovFooterBar.scss');

angular.module('kovFooterBarModule', [])

.component('kovFooterBar', require('./kovFooterBar.js'));

module.exports = 'kovFooterBarModule';